// React
import React, { useState, useEffect } from 'react';
import { BeatLoader } from 'react-spinners';

// Kendo
import kendo from '@progress/kendo-ui';
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import koMessage from '../../../com/ko-language.json';
import { Button } from '@progress/kendo-react-buttons';

// Css
import './managerMngt.css';
import styles from './managerMngt.module.css';
import { Create, Delete } from '@material-ui/icons';

// Service
import { getManagerDataListByTest } from '../../../service/mngt/managerService_test';
import { checkDuplicatedId, getManagerDataList, setDeleteManager, setManagerInsert, setManagerUpdate, setUpdateManager } from '../../../service/mngt/managerService';

// Filter
import CustomFilter from '../../com/gridFilter/custom_filter';
import GridColumnInputFilter from '../../com/gridFilter/gridColumnInputFilter';

// Translate
import { IntlProvider, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import ManagerInfo from './managerInfo';
import { getUser, isAdmin } from '../../../service/authService';
import { useHistory } from 'react-router-dom';
loadMessages(koMessage, 'ko-KR');

const ManagerMngt = ({ conn, codeList, rgnList, dongList }) => {
  const history = useHistory();
  /* -------------------------------------------------------------- useState 및 변수  */
  // 테스트 여부 플래그
  const isTest = 'N';
  const [loading, setLoading] = useState(false);
  // 페이저
  const [pager, setPager] = useState({
    total: 0,
    skip: 0,
    take: 20,
    userTerm: '',
    rgnCode: getUser().rgnCode,
    dongCode: '',
  });
  // 담당자 리스트
  const [managerList, setManagerList] = useState([]);

  // 담당자 정보 Dialog
  const [managerInfo, setManagerInfo] = useState({
    visible: false,
    isNew: false,
    dataItem: {},
  });

  /* -------------------------------------------------------------- service 및 데이터 조회  */

  const getManagerList = () => {
    if (isTest === 'Y') {
      getManagerDataListByTest(conn, getManagerResultList, getRejection, pager);
    } else {
      setLoading(true);
      getManagerDataList(conn, getManagerResultList, getRejection, pager, setLoading);
    }
  };

  // 조회 callback
  const getManagerResultList = result => {
    pager.total = result.total;
    setManagerList(result.results);
  };

  // 공용 rejection
  const getRejection = reject => {
    console.log('getRejection = ', reject);
  };

  /* -------------------------------------------------------------- changeEvent clickEvent  */
  // 수정 버튼
  const isEditEvtBtn = dataItem => {
    setManagerInfo(managerInfo => {
      const item = { ...managerInfo };
      item.visible = true;
      item.isNew = false;
      item.dataItem = dataItem;
      return item;
    });
  };

  // 삭제 버튼
  const isDeletedBtn = dataItem => {
    // const {userId} = props.dataItem;
    // 삭제 여부 확인
    kendo
      .confirm(dataItem.userTerm + ' 담당자를 삭제 하시겠습니까?')
      .then(e => {
        setDeleteManager(conn, dataItem.userId)
          .then(() => {
            kendo.alert(dataItem.userTerm + ' 담당자를 삭제 하였습니다.');
            getManagerList();
          })
          .catch(error => console.log('담당자 삭제 오류', error));
      })
      .catch(e => {
        kendo.alert('삭제 취소 하였습니다.');
        return;
      });
  };

  // 필터
  const rgnFilterDropDown = CustomFilter(dongList, { dongCode: '', dongTerm: '시/군/구' }, 'dongCode', 'dongTerm', true);

  // 그리드 페이징 처리
  const handlePageChange = e => {
    const { take, skip } = e.page;
    pager.skip = skip;
    pager.take = take;
    getManagerList();
  };

  // 그리드 필터링 처리
  const handleFilterChange = e => {
    // 필터 값 설정
    const isFilter = e.filter.filters[0];
    if (isFilter.field === 'userTerm') {
      pager.userTerm = isFilter.value;
    } else if (isFilter.field === 'dongCode') {
      pager.dongCode = isFilter.value.dongCode;
    }
    getManagerList();
  };

  // 추가 버튼 이벤트
  const addRowEvtBtn = () => {
    setManagerInfo(managerInfo => {
      const item = { ...managerInfo };
      item.visible = true;
      item.isNew = true;
      return item;
    });
  };

  // 저장 이벤트
  const submitData = dataItem => {
    const validation = validationCheck(dataItem);
    if (validation.check === false) {
      kendo.alert(validation.message);
      return;
    }
    setManagerInfo(managerInfo => {
      const item = { ...managerInfo };
      item.visible = false;
      item.isNew = false;
      return item;
    });
    setManager(dataItem);
  };

  // 저장 API
  const setManager = data => {

    if(managerInfo.isNew) {
      setManagerInsert(conn, data)
        .then(() => {
          kendo.alert('담당자 등록 완료');
          getManagerList();
        })
        .catch(error => console.log(error));
    } else {
      setManagerUpdate(conn, data)
        .then(() => {
          kendo.alert('담당자 수정 완료');
          getManagerList();
        })
        .catch(error => console.log(error));
    }

  };

  // Validation Check
  const validationCheck = dataItem => {
    let message = '';
    let check = true;

    if (!dataItem.userId) {
      check = false;
      message = '담당자 ID를 작성하지 않았습니다. 담당자 ID를 작성 해주세요.';
    } else if (!dataItem.userTerm) {
      check = false;
      message = '담당자 이름을 작성하지 않았습니다. 담당자 이름을 작성 해주세요.';
    } else if (!dataItem.userPhone) {
      check = false;
      message = '담당자 연락처를 작성하지 않았습니다. 담당자 연락처를 작성 해주세요.';
    } else if (!dataItem.rgnCode) {
      check = false;
      message = '담당자 담당지역을 선택하지 않았습니다. 담당 시군구를 선택 해주세요.';
    } else if (!dataItem.dongCode) {
      check = false;
      message = '담당자 담당지역을 선택하지 않았습니다. 담당 읍면동을 선택 해주세요.';
    } else if (!dataItem.userPassword) {
      check = false;
      message = '비밀번호를 입력해주세요.';
    }

    // 확인 비밀번호와 비밀번호 비교
    if (dataItem.userPassword) {
      if (!dataItem.userPasswordConfirm) {
        check = false;
        message = '확인 비밀번호를 입력하지 않으셨습니다. 확인 비밀번호 입력 해주세요.';
      } else {
        if (dataItem.userPassword !== dataItem.userPasswordConfirm) {
          check = false;
          message = '비밀번호와 확인 비밀번호가 입력한 값이 서로 다릅니다. 비밀번호와 확인 비밀번호를 같게 입력 해주세요.';
        } else {
          const pwdRegex = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/);
          const pwdValidator = pwdRegex.test(dataItem.userPassword);
          if (pwdValidator === false) {
            check = false;
            message = '비밀번호를 8자 이상 영문,숫자,특수문자 입력 해주세요.';
          }
        }
      }
    }

    if (dataItem.protectorPhone) {
      const phoneRegex = new RegExp(/[01](0|1|6|7|8|9)-(\d{4}|\d{3})-\d{4}$/);
      const phoneValidator = phoneRegex.test(dataItem.protectorPhone);
      if (!phoneValidator) {
        check = false;
        message = '개인 연락처 형식은 010-1234-5678 입니다. 형식에 맞게 입력해주세요.';
      }
    }

    // 새로운 계정 시
    if (managerInfo.isNew === true) {
      if (!dataItem.userPassword) {
        check = false;
        message = '비밀번호를 입력하지 않았습니다. 비밀번호를 입력 해주세요.';
      } else if (!dataItem.userPassword) {
        check = false;
        message = '확인 비밀번호를 입력하지 않았습니다. 비밀번호를 입력 해주세요.';
      }
    }

    return { check: check, message: message };
  };

  /* --------------------------------------------------------------------- gridCell  */
  const dongCell = e => {
    const { dataItem } = e;
    const result = dongList.find(item => item.dongCode === dataItem.dongCode);
    return (
      <td>
        {result ? (
          <>
            {result.dongTerm} {dataItem.address}
          </>
        ) : null}
      </td>
    );
  };

  /* -------------------------------------------------------------- useEffect  */
  useEffect(() => {
    if (!isAdmin()) {
      alert('권한이 없습니다.');
      history.push('/');
    }
    getManagerList();
  }, []);

  return (
    <div>
      <div>
        <Button onClick={addRowEvtBtn} icon="add">
          추가
        </Button>
      </div>
      <div
        className={styles.gridArea}
        style={
          loading
            ? {
                opacity: 0.6,
                pointerEvents: 'none',
                position: 'relative',
              }
            : null
        }>
        <LocalizationProvider language="ko-KR">
          <IntlProvider locale="ko">
            <Grid
              className="managerListGrid"
              style={{ height: '100%' }}
              data={managerList}
              skip={pager.skip}
              take={pager.take}
              total={pager.total}
              pageable
              filterable={true}
              onPageChange={handlePageChange}
              onFilterChange={handleFilterChange}>
              <GridColumn field="userId" title="ID" filterable={false} />
              <GridColumn field="userTerm" title="성함" filterCell={GridColumnInputFilter} />
              <GridColumn field="dongCode" title="담당지역" filterCell={rgnFilterDropDown} cell={dongCell} />
              <GridColumn field="userPhone" title="사무실 연락처" filterable={false} />
              <GridColumn field="protectorPhone" title="개인 연락처" filterable={false} />
              <GridColumn field="regiDtm" title="등록일시" filterable={false} />
              <GridColumn
                title="수정"
                filterable={false}
                sortable={false}
                width={60}
                cell={props => (
                  <td>
                    <a
                      onClick={e => {
                        e.preventDefault();
                        isEditEvtBtn(props.dataItem);
                      }}>
                      <i>
                        <Create />
                      </i>
                    </a>
                  </td>
                )}
              />
              <GridColumn
                title="삭제"
                filterable={false}
                sortable={false}
                width={60}
                cell={props => (
                  <td>
                    <a
                      onClick={e => {
                        e.preventDefault();
                        isDeletedBtn(props.dataItem);
                      }}>
                      <i>
                        <Delete />
                      </i>
                    </a>
                  </td>
                )}
              />
              <GridNoRecords>데이터가 존재하지 않습니다.</GridNoRecords>
            </Grid>
            {loading && (
              <p
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%,-50%)',
                }}>
                <BeatLoader loading={true} size={24} color="#1e88e5" />
              </p>
            )}
          </IntlProvider>
        </LocalizationProvider>
        {managerInfo.visible === true && (
          <ManagerInfo
            conn={conn}
            rgnList={rgnList}
            dongList={dongList}
            isNew={managerInfo.isNew}
            submitData={submitData}
            managerInfo={managerInfo}
            setManagerInfo={setManagerInfo}
            dataItem={managerInfo.dataItem}
          />
        )}
      </div>
    </div>
  );
};
export default ManagerMngt;
